import React from 'react';
import { FadeIn } from './Shared';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-137">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-138"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-139">
        <FadeIn data-id="element-140">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-pink-500/10 mb-10 border border-pink-500/20" data-id="element-141">
            <ShieldCheck className="w-12 h-12 text-pink-400" data-id="element-142" />
          </div>
          <h2 className="text-3xl md:text-5xl text-white mb-8 tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-143">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="md:text-2xl text-gray-200 mb-12 font-sans font-medium opacity-90 text-[18px]" data-id="element-144">
            Abrís los Tomos. Los aplicás en tu negocio. Si en 7 días no es lo
            que esperabas: devolución del 100% sin formularios, sin drama, sin
            preguntas.
          </p>
          <div className="inline-block bg-navy-900/60 px-8 py-4 rounded-full border border-white/10" data-id="element-145">
            <span className="text-gray-300 font-bold tracking-wide uppercase text-xs md:text-sm font-sans" data-id="element-146">
              Tasa de devoluciones:{' '}
              <span className="text-pink-400 font-bold ml-2" data-id="element-147">
                menos del 1%.
              </span>
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};